export default __webpack_public_path__ + "static/media/Eric.53f83929.jpg";